import { Link } from "react-router-dom";
import { SubTitle3, Title2 } from "@components/new/Typo";
import Icon from "@components/new/Icon";
import ExternalLinkIcon from "@assets/icons/outline/external-link.svg?react";
import styles from "./Table.module.scss";

export type TableCellLinkProps = {
  title: string;
  description?: string;
  to: string;
  external?: boolean;
  maxWidth?: string;
  thirdLine?: React.ReactNode;
};

export function TableCellLink(props: TableCellLinkProps): JSX.Element {
  const linkIcon = <Icon className={styles.linkCellIcon} icon={ExternalLinkIcon} />;

  return (
    <div className={styles.linkCell} style={{ maxWidth: props.maxWidth }}>
      <div className={styles.linkCellTitleRow}>
        <Title2 ellipsis lines={2}>{props.title}</Title2>
        {props.to ? (
          props.external ? (
            <a
              className={styles.linkCellLink}
              href={props.to}
              target="_blank"
              rel="noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {linkIcon}
            </a>
          ) : (
            <Link
              className={styles.linkCellLink}
              to={props.to}
              onClick={(e) => e.stopPropagation()}
            >
              {linkIcon}
            </Link>
          )
        ) : null}
      </div>
      {props.description ? (
        <SubTitle3 color="grey-800" ellipsis lines={1}>{props.description}</SubTitle3>
      ) : null}
      {props.thirdLine ? (
        <SubTitle3 color="grey-700" ellipsis lines={1}>{props.thirdLine}</SubTitle3>
      ) : null}
    </div>
  );
}
